interface IConditionalProps {
  children: React.ReactElement;
  condition: boolean;
  wrapper: (children: React.ReactElement) => React.ReactElement;
}

const ConditionalWrapper = ({ condition, wrapper, children }: IConditionalProps) =>
  condition ? wrapper(children) : children;

export default ConditionalWrapper;
